import React from 'react'
import PageHeader from '../components/PageHeader'
import PopularCruiseLines from '../components/PopularCruiseLines'
import LuxuryCruiseLines from '../components/LuxuryCruiseLines'

const OurPartnerCruiseLines = () => {
    return (
        <>
            <PageHeader
                title="Our Partner Cruise Lines "
                image="img/cruise.jpg" // use your own path
                breadcrumbs={[
                    { label: "Our Partner Cruise Lines", active: true },
                ]}
            />

            <PopularCruiseLines />
            <LuxuryCruiseLines />
        </>
    )
}

export default OurPartnerCruiseLines